<template>
	<Service class="tact">
		<h2>Service</h2>

		<p class="year">2017</p>

		<h3>TACT（タクト）</h3>

		<p class="event">Hackin’ Honda - 探し出せ！新しい方程式を！ 審査員賞</p>
		<p class="role">logo / UI Design / coding / Illustration</p>

		<section class="logo content-box">
			<h4>Logo</h4>
			<img src="images/service/tact/logo.png" />
			<p>オーケストラの指揮をするように、運転の指揮をとってくれる。</p>
		</section>

		<section class="target content-box">
			<h4>Target</h4>
			<p>わりとよく通勤などで運転をする。20〜30代のスマホを使いこなす、Spotifyで音楽をよく聴く世代。</p>
		</section>

		<section class="problem content-box">
			<h4>Problem</h4>
			<p>
				その日の気分、運転する時間、道などで変わる運転。
				ムラがでて、危険な走りになったりする。 イライラするとムラのある運転になり、事故が起きやすくなる。
			</p>
		</section>

		<section class="solution content-box">
			<h4>Solution</h4>

			<p>
				走りによって音楽で、運転手の気分を落ち着かせたり、危険な運転の警告を促す。
				音楽を聴くことで、運転を楽しくさせる。
			</p>
		</section>

		<section class="about-service">
			<h4>Service</h4>
			<img src="images/service/tact/board.png" />
			<p>
				検証・データ取り動画
				<iframe
					class="youtube"
					width="560"
					height="315"
					src="https://www.youtube-nocookie.com/embed/GHC7Wvx85QI"
					frameborder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
				></iframe>
			</p>
		</section>

		<section class="design">
			<h4>Design</h4>
			<p>画面の顔と音楽で、危険な運転の警告や、穏やかな運転を促す。</p>
			<img src="images/service/tact/faces.png" />
			<img src="images/service/tact/screen.png" />
		</section>
	</Service>
</template>

<style lang="scss" scoped>
.tact {
	.top {
		img {
			width: 600px;
			margin: 0 auto;
		}
	}

	.logo {
		> img {
			width: 275px;
			margin-bottom: 30px;
		}

		p {
			width: 320px;
			margin: 0 auto;
		}
	}

	.about-service {
		width: 768px;

		img {
			margin-bottom: 30px;
		}

		p {
			display: flex;
			flex-direction: column;
			align-items: center;
		}
	}

	.design {
		p {
			text-align: center;
			margin-bottom: 20px;
		}

		img {
			width: 600px;
			margin: 0 auto 24px;
		}
	}
	@media screen and (max-width: 480px) { 
.top {
		img {
			width: 100%;
			margin: 0 auto;
		}
	}

	.logo {
		> img {
			width: 275px;
			margin-bottom: 30px;
		}

		p {
			width: 100%;
			margin: 0 auto;
		}
	}

	.about-service {
		width: 100%;

		img {
			margin-bottom: 30px;
		}

		p {
			display: flex;
			flex-direction: column;
			align-items: center;
		}
	}

	.design {
		p {
			text-align: center;
			margin-bottom: 20px;
		}

		img {
			width: 100%;
			margin: 0 auto 24px;
		}
	}
	iframe{
		width: 100%;
	}



	}
}
</style>

<script>
import Service from "@/components/Service.vue";

export default {
	components: {
		Service
	}
};
</script>
